const ACCOUNT_SUBSCRIPTION_PLAN_DEFAULT: string = 'default';

export default ACCOUNT_SUBSCRIPTION_PLAN_DEFAULT;
